import { useState, useEffect, useRef } from 'react';
import './About.css';

const About = () => {
  const [currentFrame, setCurrentFrame] = useState(0);
  const containerRef = useRef(null);
  const totalFrames = 200;

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const section = containerRef.current;
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Calculate scroll progress based on section position
      const sectionTop = rect.top;
      const sectionHeight = rect.height;
      
      if (sectionTop < windowHeight && sectionTop + sectionHeight > 0) {
        // Section is in viewport - animate based on viewport position
        const scrollProgress = Math.max(0, Math.min(1, 
          (windowHeight - sectionTop) / (windowHeight + sectionHeight)
        ));
        
        const frameIndex = Math.floor(scrollProgress * (totalFrames - 1));
        setCurrentFrame(frameIndex);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Generate image path with proper padding
  const getImagePath = (frameNumber) => {
    const paddedNumber = String(frameNumber).padStart(5, '0');
    return `/about us/Comp 1_${paddedNumber}.jpg`;
  };

  return (
    <section id="about" className="about section" ref={containerRef}>
      <div className="about-content">
        <div className="about-image">
          <img 
            src={getImagePath(currentFrame)}
            alt="Villa zoom sequence" 
          />
        </div>
        <div className="about-text">
          <h2 className="about-title">"In Our Nature"</h2>
          <div className="about-description">
          <p>
              "Amoda" means joy, and "Sari" means essence — together, they form the essence of<br />
              joy. At Amoda Sari, every space is designed to reconnect you with what truly<br />
              matters — stillness, nature, and community.<br />
              <br />
              We're not here to impress; we're here to breathe.<br />
              Amoda Sari was born from the urge to step away — from screens, from noise,<br />
              from rush. Here, mornings stretch a little longer, conversations flow easier, and nature<br />
              sets the pace. We believe calm can be social, design can be kind, and everyone<br />
              deserves a space that feels like pause.
            </p>
          </div>
          <div className="about-buttons">
            <a href="/about" className="btn btn-primary" role="button">Read more..</a>
            <a href="/AMODA SARI BROCHURE.pdf" className="btn btn-primary" download>Brochure</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
